export const MAIL_SEQUENCE_FIELD_LABEL_CLASS =
  'mb-2 block text-body font-medium text-secondary-150';

/** Inline links in Schedule Mail alerts/errors — matches ScheduledMailDetails. */
export const MAIL_SEQUENCE_ALERT_LINK_CLASS =
  'font-medium text-secondary-125 hover:text-secondary-150 hover:underline';
